// extracted by mini-css-extract-plugin
export default {"optionsModal":"Option_optionsModal__Uo0F1","overlay":"Option_overlay__vIqNR"};